module.exports = __webpack_public_path__ + "d78e68d1.webp";